export default __webpack_public_path__ + "static/media/extortion.8274fd72.svg";